"use client";
import { useEffect, useState } from "react";
import { usePathname, useSearchParams } from "@/lib/router-compat";
import { useNavigation } from "react-router-dom";
import { Loader2 } from "lucide-react";

const MAX_WAITING_MS = 8000;

export function NavigationLoadingOverlay() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const navigation = useNavigation();
  const [isExplicitLoading, setIsExplicitLoading] = useState(false);

  // クリック自体は遷移ではない。離脱確認で止められたリンク・戻る操作には
  // 表示せず、Routerの実際の待機状態と通信の開始・終了通知だけを使う。
  useEffect(() => {
    const start = () => setIsExplicitLoading(true);
    const settle = () => setIsExplicitLoading(false);
    window.addEventListener("app:navigation-start", start);
    window.addEventListener("app:navigation-settle", settle);
    return () => {
      window.removeEventListener("app:navigation-start", start);
      window.removeEventListener("app:navigation-settle", settle);
    };
  }, []);

  // 遷移完了後に見せるためだけの250ms待機は追加しない。
  useEffect(() => {
    setIsExplicitLoading(false);
  }, [pathname, searchParams]);

  // 明示的な開始後に終了通知が失われた場合だけ、安全タイムアウトを残す。
  useEffect(() => {
    if (!isExplicitLoading) return;
    const t = setTimeout(() => {
      setIsExplicitLoading(false);
    }, MAX_WAITING_MS);
    return () => clearTimeout(t);
  }, [isExplicitLoading]);

  if (!isExplicitLoading && navigation.state === "idle") return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="bg-background/40 absolute inset-0 z-40 flex items-center justify-center backdrop-blur-sm"
    >
      <div className="bg-card flex flex-col items-center gap-3 rounded-(--radius-container) px-6 py-5 shadow-lg">
        <Loader2
          className="text-primary size-10 animate-spin motion-reduce:animate-none"
          aria-hidden="true"
        />
        <p className="text-muted-foreground text-sm">読み込み中…</p>
      </div>
    </div>
  );
}
